let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jKRQn")).then(() => parcelRequire('lULvF'));